import europeanFund from "../static/european-fund.png";
import europeanFund2 from "../static/european-fund2.png";

export const bg = {
  navbar: {
    home: "Начало",
    aboutUs: "За нас",
    services: "Услуги",
    gallery: "Галерия",
    contacts: "Контакти",
  },

  home: {
    titleSection: {
      title: "Кои сме ние?",
      desc: "Вече 20 години превозваме Вашите товари и свързваме бизнеса Ви с европейския пазар!",
      subtitle1: "Нашата дейност",
      desc1:
        "Нашата основна дейност е автомобилният международен транспорт на стоки и товари, осигурявайки висококачествени услуги за нашите клиенти.",
      subtitle2: "Нашите принципи",
      desc2:
        "Вярваме, че предлаганите висококачествени услуги, индивидуалният подход, както и бързите гъвкави решения в комбинация с дългогодишният ни опит, са причините, поради които нашите клиенти ни избират.",
      subtitle3: "Партньорства и доверие",
      desc3:
        "Днес Класик 2000 ООД успешно си сътрудничи с водещите български и международни компании в транспортната логистика и спедиция.",
    },

    statistics: {
      title: "Цифри и факти",
    },

    ourOffers: {
      title: "Какво ви предлагаме",
      subtitle1: "Транспорт",
      desc1:
        "Основните дестинации от/до, които превозваме товари са: Гърция, България, Германия, Нидерландия, Белгия, Люксембург, Франция, Дания, Норвегия, Швеция, Финландия, Литва, Латвия, Естония, Полша...",
      subtitle2: "Складиране и ТРО",
      desc2:
        "Можем да предложим складова площ 1000 m² с възможност за разделяне на 2 х 500 m² и товаро-разтоварни операции с мотокар до 4 тона...",
      subtitle3: "Охраняем паркинг за камиони",
      desc3:
        "Паркингът се намира в базата ни. Локацията е удобна, защото се намира на влизане в град Видин...",
      subtitle4: "Сервиз",
      desc4:
        "Предлагаме широк обхват от ремонтни услуги за тежкотоварни автомобили в собствен сервиз...",
      button: "Прочетете повече",
    },

    form: {
      title: "Изпратете запитване",
      companyName: "Име на фирмата",
      contactPerson: "Лице за контакт",
      email: "E-mail адрес",
      phoneNumber: "Телефонен номер",
      messageSubject: "Тема за запитване",
      messageDesc: "Описание на запитването",
      button: "Изпрати запитване",
    },
  },

  aboutUs: {
    title: "За нас",
    subtitle1: "Кога?",
    desc1:
      "Класик 2000 е семейна фирма, започнала своята дейност през далечната вече 2004-а година. Започнахме без опит и само с един малък камион. С много труд, постоянство и коректност, печелим първите си редовни клиенти. 20 години по-късно Класик 2000 е едно утвърдено и познато име в българския транспортен бранш и продължава своето успешно развитие, въпреки многото трудности през годините.",
    subtitle2: "Къде?",
    desc2:
      "Седалището ни е в град Видин, България. След много инвестиции през 2015-а успяхме да обединим цялата ни дейност на едно място, съчетаващо офиси, складове, паркинг и сервиз. Локацията ни е на входа на град Видин и предлага бърза удобна връзка с Дунав мост-2 и международен път Е-79. Това е от ключово значение за процеса на работа при предлагането на бързи и ефикасни транспортни решения.",
    subtitle3: "Как?",
    desc3:
      "С много труд, отдаденост и постоянство изградихме това, което сме днес. Опитният ни екип е на Ваше разположение, за да намери най-доброто транспортно решение.",

    card: "обърни",
    titleFront1: "Нашата мисия",
    titleBack1: "Нашата мисия е:",
    descBack1: {
      desc1:
        "Успешно сътрудничество в дългосрочен план с различните видове товародатели и изпълнение на желаните от тях изисквания за транспорт;",
      desc2:
        "Да бъдем социално и обществено отговорни и да продължим да осигуряваме работни места за нашия регион;",
      desc3:
        "Да бъдем партньор на своите клиенти, допринасяйки към взаимните бизнес отношения с лоялност и коректност.",
    },
    titleFront2: "Нашата визия",
    titleBack2: "Нашата визия е:",
    descBack2: {
      desc1:
        "Постоянно да търсим нови начини и методи за оптимизация на работните процеси;",
      desc2:
        "Да поддържаме и/или увеличаваме броя на превозните средства в автопарка;",
      desc3: "Успешно да развиваме един задружен и мотивиран екип;",
      desc4: "Да поддържаме своето добро име и позиция на транспортния пазар.",
    },
  },

  services: {
    transport: {
      title: "Транспортни услуги",
      subtitle1: "Основни дестинации",
      desc1:
        "Основните дестинации от/до, които превозваме товари са: Гърция, България, Германия, Нидерландия, Белгия, Люксембург, Франция, Дания, Норвегия, Швеция, Финландия, Литва, Латвия, Естония, Полша. При запитване имаме възможност за превози и от/за други релации на територията на Европейския съюз.",
      subtitle2: "Превози и типове товари",
      desc2:
        "Извършваме превози основно на цели товари (FTL), но при възможност предлагаме и групажни превози (LTL).",
      subtitle3: "Специализация в превоза на дрехи",
      desc3:
        "Специализирани сме в превоза на дрехи на закачалки в специални ремаркета фургони. С този тип превози стартира и нашата дейност.",
      subtitle4: "Нашият автопарк",
      desc4:
        "За целите на дейността, Класик 2000 разполага със съвременен автопарк от около 50 товарни автомобила, състоящ се от влекачи с полуремаркета.",
    },

    services: {
      title: "Сервизни услуги",
      subtitle1: "Нашите услуги",
      desc1:
        "Предлагаме широк обхват от ремонтни услуги за тежкотоварни автомобили в собствен сервиз с нужното оборудване за:",
      item1: "диагностика;",
      item2:
        "ремонти и техническа поддръжка на товарни автомобили, влекачи, ремаркета и полуремаркета;",
      item3: "демонтаж и монтаж на тежки гуми;",
      item4: "професионални заваръчни дейности;",
      item5: "други услуги.",
      subtitle2: "Мобилен сервиз",
      desc2:
        "Към редовната сервизна услуга разполагаме и със специализиран мобилен сервиз за ремонти на аварирали товарни автомобили на пътя.",
      desc3:
        "Мобилният сервиз работи на запитване. Възможност за отзоваване в  почивни дни и извънработно време.",
    },

    storage: {
      title: "Склад и товарене & разтоварване",
      titleDesc:
        "Можем да предложим складова площ 1000 m² с възможност за разделяне на 2 х 500 m² и товаро-разтоварни операции с мотокар до 2,5 тона.",
      subtitle1: "Услуги",
      item1: "24 часова охрана",
      item2: "24 часово видео наблюдение на стоката",
      subtitle2: "Крос-док операции",
      desc: "Извършваме и крос-док операции. Можем временно да складираме Ваша стока и да я претоварим за доставка на друг автомобил в желано от Вас време.",
    },

    parking: {
      title: "Охраняем ТИР паркинг във Видин",
      titleDesc:
        "Паркингът се намира в базата ни. Локацията е удобна, защото се намира на влизане в град Видин. На около километър след отбивката за околовръстен път водещ към Дунав Мост 2.",
      subtitle1: "Предоставяме:",
      item1: "денонощна жива охрана;",
      item2: "24 часово видео наблюдение;",
      item3: "безплатен Wi-Fi интернет;",
      item4: "кафе машина;",
      item5: "WC.",
      subtitle2: "В близост:",
      item6: "център град Видин;",
      item7: "бензиностанция SHELL;",
      item8: "хранителни магазини и банки.",
    },
  },

  gallery: {
    title: "Галерия",
    titleDesc1: "Централен офис на Класик2000 в град Видин, България.",
    titleDesc2: "Сервизни помещения, ТИР паркинг и складове в един комплекс.",
  },

  contacts: {
    title: "Контакти",
    phoneTitle: "Телефон:",
    phoneDesc1: "+359 94 62 60 60 - офис",
    phoneDesc2: "+359 899 610 075 - сервиз (от 09ч до 17ч)",
    workingHoursTitle: "Работно време офис и сервиз:",
    workingHoursDesc1: "Понеделник - петък 09:00 - 17.30 ч.",
    workingHoursDesc2: "Почивни дни - събота и неделя",
    addressTitle: "Офис, сервизна база, паркинг",
    addressDesc1: "Южна промишлена зона (до КАТ)",
    addressDesc2: "Гр. Видин, България",
    addressDesc3: "GPS локация: 43.972651, 22.868933",
  },

  footer: {
    aboutUs: "За Класик 2000 ООД",
    services: "Транспортни услуги",
    cookies: "Политика за поверителност",
    signals: "Подаване на сигнали по ЗЗЛПСПОИН",
    project: "Европейски фонд",

    contacts: "Контакти",
    request: "Пишете ни",
    address1: "Град Видин, България",
    address2: "Южна промишлена зона",

    socials: "Социални мрежи",
    facebook: "Facebook страница",
  },

  gdpr: {
    title: "ПОЛИТИКА ЗА ПОВЕРИТЕЛНОСТ",
    text: `<div>
      <div>
        <h2>ПРЕДМЕТ</h2>
        <p>
          Чл. 1. Настоящата ПОЛИТИКА ЗА ПОВЕРИТЕЛНОСТ (по-долу „Политиката“) е
          приета от „КЛАСИК-2000“ ООД, с ЕИК 123541852, (по-долу „КЛАСИК-2000“),
          в качеството му на администратор на лични данни, съобразно
          изискванията на Регламент (ЕС) 2016/679 на Европейския парламент и на
          Съвета от 27 април 2016 година относно защитата на физическите лица
          във връзка с обработването на лични данни и относно свободното
          движение на такива данни (по-долу „Общият регламент на ЕС относно
          защитата на данните“ или „ОРЗД“) и Закона за защита на личните данни
          (по-долу „ЗЗЛД“).
        </p>
        <p>
          Чл. 2. (1) Правото на поверителност на личните данни е основен
          приоритет на КЛАСИК-2000. КЛАСИК-2000 изпълнява стриктно приложимите
          разпоредби на националното и европейско законодателство по отношение
          на защитата и сигурното съхранение на личните данни на служители,
          контрагенти и партньори, както и на физическите лица, които са
          предоставили своите лични данни чрез формите за комуникация на
          Интернет страница с адрес https://classic2000.bg/ (по-долу „САЙТА“).
        </p>
        <p>
          (2) КЛАСИК-2000 спазва основните принципи, въведени като задължителни
          при обработването на лични данни: законосъобразност, добросъвестност и
          прозрачност, ограничение на целите, свеждане на данните до минимум,
          точност, ограничение на съхранението, цялостност и поверителност,
          отчетност.
        </p>
        <p>
          (3) Настоящата Политика за поверителност не обхваща изцяло дейността
          на КЛАСИК-2000, а цели да информира субектите на данни относно
          обработването на лични данни при ползването на Интернет страница с
          адрес https://classic2000.bg/
        </p>
      </div>

      <div>
        <h2>ДЕФИНИЦИИ</h2>
        <p>
          Чл. 3. Използваните в настоящата Политика термини имат значението,
          което е дефинирано в ОРЗД.
        </p>
      </div>

      <div>
        <h2>КОЙ ОБРАБОТВА ВАШИТЕ ЛИЧНИ ДАННИ?</h2>
        <p>
          Чл. 4. Администратор на лични данни е „КЛАСИК-2000“ ООД, с ЕИК
          123541852, със седалище и адрес на управление в гр. София, 1233, ул.
          Генерал Столетов №27, вх. В, ет. 8, ап. 27, с адрес на кореспонденция:
          гр. Видин, Южна промишлена зона /до КАТ/ автобаза Класик 2000.
        </p>
      </div>

      <div>
        <h2>ДАННИ ЗА КОНТАКТ С АДМИНИСТРАТОРА</h2>
        <p>Чл. 5. Администраторът има следните данни за кореспонденция:</p>
        <ul>
          <li>
            Адрес по седалище: гр. София, ул. Генерал Столетов №27, вх. В, ет.
            8, ап. 27;
          </li>
          <li>
            Адрес за кореспонденция: гр. Видин, Южна промишлена зона /до КАТ/
            автобаза Класик 2000
          </li>
          <li>Електронен адрес: ;</li>
          <li>Телефон: +359 94626060</li>
        </ul>
      </div>

      <div>
        <h2>КОГА ОБРАБОТВАМЕ ЛИЧНИ ДАННИ?</h2>
        <p>
          Чл. 6. КЛАСИК-2000 не събира лични данни самоцелно и без ограничение.
          КЛАСИК-2000 събира само онези лични данни, които са необходими за
          изпълнение на съответните законосъобразни дейности на дружеството.
          Дейностите, свързани с ползването на САЙТА, при които се обработват
          лични данни, са свързани с формите за комуникация на САЙТА, посочени
          по-долу.
        </p>
      </div>

      <div>
        <h2>ФИЗИЧЕСКИ ЛИЦА, ЧИИТО ЛИЧНИ ДАННИ ОБРАБОТВАМЕ</h2>
        <p>
          Чл. 7. Чрез САЙТА, КЛАСИК-2000 обработва лични данни на следните
          категории физически лица:
        </p>
        <ul>
          <li>Регистрирани потребители на САЙТА;</li>
          <li>
            Лица, които са предоставили свои лични данни чрез контактната форма
            и са направили заявка за транспортно-логистичните услуги на САЙТА;
          </li>
          <li>
            Кандидати за работа, които са предоставили свои лични данни чрез
            контактната форма за кандидатстване за работа на САЙТА;
          </li>
          <li>
            Лица, които са предоставили свои лични данни чрез контактна форма за
            запитвания чрез САЙТА.
          </li>
        </ul>
      </div>

      <div>
        <h2>КАТЕГОРИИ ЛИЧНИ ДАННИ, КОИТО ОБРАБОТВАМЕ</h2>
        <p>
          Чл. 8. (1) При изпълнение на дейностите, свързани със САЙТА,
          КЛАСИК-2000 обработва лични данни, предоставени директно от субектите
          на данни. В този смисъл субектите на данни сами определят обема от
          лични данни, които да предоставят с оглед различните цели. КЛАСИК-2000
          съхранява единствено личните данни, които са необходими за изпълнение
          на целите на обработването, като например:
        </p>
        <ul>
          <li>
            При регистрация в САЙТА или при ползване на формите за комуникация в
            САЙТА, изброени по-горе, КЛАСИК-2000 обработва единствено обикновени
            лични данни – имена, имейл адрес и телефонен номер;
          </li>
          <li>
            КЛАСИК-2000 обработва и личните данни, поместени в автобиографиите
            на лицата, които са ползвали контактната форма на САЙТА с цел
            кандидатстване за работа, например данни за имена, образованието,
            семейното положение, местоживеенето, местоработата, телефон,
            осигурителната история и пр.
          </li>
        </ul>
      </div>

      <div>
        <h2>ЦЕЛИ НА ОБРАБОТВАНЕ</h2>
        <p>
          Чл. 9. КЛАСИК-2000 обработва лични данни само за конкретни и легитимни
          цели и не ги обработва по-нататък по начин, несъвместим с установените
          цели. КЛАСИК-2000 обработва лични данни, получени чрез САЙТА, за
          следните цели:
        </p>
        <ul>
          <li>
            Подбор на служители по трудово право отношение, ако кандидатстването
            е през контактната форма на сайта;
          </li>
          <li>
            Предоставяне на информация за услугите на дружеството, в случай на
            получено запитване;
          </li>
          <li>
            Осъществяване на връзка с лица, които са заявили интерес към
            услугите на КЛАСИК-2000, с оглед търговската дейност на дружеството;
          </li>
          <li>
            Осъществяване на връзка с потенциални контрагенти или потребители
            посредством формите за комуникация на САЙТА, включително при
            заявяване на съгласие за получаване на съобщения от САЙТА;
          </li>
        </ul>
      </div>

      <div>
        <h2>ПРАВНИ ОСНОВАНИЯ ЗА ОБРАБОТВАНЕ</h2>
        <p>
          Чл. 10. В дейностите, свързани със САЙТА, КЛАСИК-2000 обработва лични
          данни на субекти на данни на основание чл. 6, параграф 1, буква „б” и
          буква „е“ от ОРЗД, а именно:
        </p>
        <ul>
          <li>
            б) обработването е необходимо за изпълнението на договор, по който
            субектът на данните е страна, или за предприемане на стъпки по
            искане на субекта на данните преди сключването на договор /например
            при заявка за транспортна услуга, изпратена чрез САЙТА/;
          </li>
          <li>
            е) обработването е необходимо за целите на легитимните интереси на
            администратора или на трета страна, освен когато пред такива
            интереси преимущество имат интересите или основните права и свободи
            на субекта на данните, които изискват защита на личните данни,
            по-специално когато субектът на данните е дете (например – за
            управление на запитванията, получени чрез формите за комуникация на
            САЙТА и управление на кандидатурите за работа, получени чрез САЙТА).
          </li>
        </ul>
      </div>

      <div>
        <h2>НА КОГО МОЖЕ ДА ПРЕДАДЕМ ИЛИ РАЗКРИЕМ ЛИЧНИ ДАННИ?</h2>
        <p>
          Чл. 11. (1) При изпълнение на дейности, свързани със САЙТА,
          КЛАСИК-2000 може да предаде или разкрие лични данни единствено на
          компетентни държавни органи, които по силата на нормативен акт имат
          правомощия да изискват от КЛАСИК-2000 предоставянето на информация,
          сред която и лични данни – съд, разследващи органи (органите на
          полицията, следствието, прокуратурата), ДАНС, надзорни/регулаторни
          органи;
        </p>
        <p>
          (2) КЛАСИК-2000 не предава лични данни на други държави, включително
          на държави извън ЕС.
        </p>
      </div>

      <div>
        <h2>СРОК НА СЪХРАНЕНИЕ НА ЛИЧНИТЕ ДАННИ</h2>
        <p>
          Чл. 12. Продължителността на съхранение на личните данни, събрани чрез
          САЙТА, зависи от целите на обработването, за които са събрани. При
          всички случаи личните данни се съхраняват за период не по-дълъг от
          предвидения в съответния нормативен акт срок. За личните данни,
          събрани чрез САЙТА, са определени следните срокове на съхранение:
        </p>
        <ul>
          <li>
            Лични данни, предоставени чрез контактната форма на сайта за
            кандидатстване за работа на САЙТА се съхраняват за срок до 6 (шест)
            месеца съобразно чл. 25к, ал. 1 от ЗЗЛД, освен ако кандидатът е дал
            своето изрично писмено съгласие за съхранение за по-дълъг срок;
          </li>
          <li>
            Лични данни, предоставени чрез контактната форма на сайта за заявка
            за транспортно-логистичните услуги на САЙТА, се съхраняват до
            преустановяване на комуникацията със съответното лице, освен ако
            страните не предприемат действия за сключване на договор;
          </li>
          <li>
            Лични данни, предоставени чрез Общата контактна форма за запитвания
            на САЙТА, се съхраняват за периода от получаване на запитването,
            искането или въпроса, до постигане на целта на обработването им
            и/или отпадане на правното основание за обработването на съответните
            лични данни;
          </li>
          <li>
            Лични данни на регистрирани на САЙТА потребители се съхраняват до
            прекратяване на регистрацията;
          </li>
        </ul>
      </div>

      <div>
        <h2>СИГУРНОСТ НА ЛИЧНИТЕ ДАННИ</h2>
        <p>
          Чл. 13. КЛАСИК-2000 прилага всички подходящи технически и
          организационни мерки за гарантиране сигурността на личните данни,
          включително минимизиране на обема обработвани лични данни, необходим
          за постигане на съответните цели; своевременно възстановяване на
          наличността и достъпа до личните данни, в случай на физически или
          технически инцидент; поемане на изрично задължение от служителите за
          поверителност, както и други мерки. Освен това, САЙТЪТ ползва Let's
          Encrypt сертификат, който предоставя ефективно криптиране на данните
          на потребителите по време на предаването им към уеб сървъра на САЙТА.
        </p>
      </div>

      <div>
        <h2>ПРАВА НА СУБЕКТИТЕ НА ДАННИТЕ</h2>
        <p>
          Чл. 14. Всяко физическо лице, чиито данни се обработват от
          КЛАСИК-2000, има следните права:
        </p>
        <ul>
          <li>
            право на достъп до личните му данни, включително да получи копие от
            тях;
          </li>
          <li>
            право на коригиране или допълване на неточни или непълни лични
            данни;
          </li>
          <li>
            право на изтриване на лични данни, които се обработват без правно
            основание;
          </li>
          <li>
            право на ограничаване на обработването – при наличие на правен спор
            между КЛАСИК-2000 и лицето – до неговото решаване или за
            установяването, упражняването или защитата на правни претенции;
          </li>
          <li>
            право на възражение – по всяко време и на основания, свързани с
            конкретната ситуация на лицето, при условие, че не съществуват
            убедителни законови основания за обработването, които имат
            предимство пред интересите, правата и свободите на субекта на данни,
            или съдебен процес;
          </li>
          <li>
            право на преносимост – само в случай, че личните данни се обработват
            по автоматичен начин на основание съгласие или договор;
          </li>
          <li>
            право да не бъде обект на изцяло автоматизирано решение, включващо
            профилиране, което поражда правни последствия за субекта на данните
            или го засяга в значителна степен.
          </li>
        </ul>
        <p>
          В съответствие с ОРЗД и ЗЗЛД, посочените по-горе права могат да се
          упражнят чрез подаване на писмено заявление по електронен път.
          Заявлението се отправя лично от субекта на данни или от упълномощено
          от него лице.{" "}
        </p>
        <p>
          {" "}
          KЛАСИК-2000 се произнася по искането на субекта на данни в 30-дневен
          срок от неговото подаване.
        </p>
      </div>

      <div>
        <h2>ЗАЩИТА НА ПРАВАТА НА СУБЕКТИТЕ НА ДАННИТЕ</h2>
        <p>
          Чл. 15. В съответствие със Закона за защита на личните данни и
          Регламент (ЕС) 2016/679, всяко физическо лице, което счита, че правото
          му на защита на личните му данни е нарушено, може да подаде жалба до
          Комисията за защита на личните данни на адрес: гр. София 1592, бул.
          „Проф. Цветан Лазаров” № 2, интернет страница: www.cpdp.bg.
        </p>
      </div>
      </div>`,
  },

  covidSupport: {
    text: `<h1 style="text-align: center">
        Подкрепа за средни предприятия за преодоляване на икономическите
        последствия от пандемията COVID-19
      </h1>

      <div style="text-align: center">
        <img
          src=${europeanFund}
          alt="Covid Support"
          style="width: 300px"
        />
        <img
          src=${europeanFund2}
          alt="Covid Support"
          style="width: 300px"
        />
      </div>

      <p>
        Проект BG16RFOP002-2.077-0406-C01 e финансиран от Оперативна програма
        "Иновации и конкурентоспособност", съфинансирана от Европейския съюз
        чрез Европейския фонд за регионално развитие.
      </p>

      <div>
        <h2>КРАТКО ОПИСАНИЕ НА ПРОЕКТА</h2>
        <p>
          Настоящият проект се изпълнява от "КЛАСИК-2000" ООД, българско средно
          предприятие с основна дейност "Товарен автомобилен транспорт", код по
          КИД 2008 49.41 "Товарен автомобилен транспорт". Това е първи проект на
          фирмата и се реализира с финансовата подкрепата на Европейски съюз и
          Европейски фонд за регионално развитие. "КЛАСИК-2000" ООД, разработва
          настоящото проектно предложение за преодоляване икономическите
          последствия от пандемията COVID-19, в съответствие с Процедура
          BG16RFOP002-2.077 "Подкрепа за средни предприятия за преодоляване на
          икономическите последствия от пандемията COVID-19", по Оперативна
          програма "Иновации и конкурентоспособност" 2014-2020. Проектът се
          изпълнява в абсолютен синхрон с принципите на хоризонталните политики
          на ЕС, а именно насърчаване на равенството между мъжете и жените и на
          не дискриминацията, както и насърчаване на устойчивото развитие и
          опазването на околната среда. Проектът е с обща продължителност от 3
          месеца в съответствие с насоките за кандидатстване по процедурата,
          считано от датата на влизане в сила на административния договор за
          предоставяне на безвъзмездна финансова помощ от 03.02.2021 г. до
          03.05.2021 г.
        </p>
      </div>

      <div>
        <h2>ЦЕЛ НА ПРОЕКТА</h2>
        <p>
          Основна цел на настоящото проектно предложение е осигуряването на
          оперативен капитал за предприятието "КЛАСИК-2000" ООД за преодоляване
          на последиците от пандемията COVID-19, което от своя страна ще доведе
          до гарантиране на стабилен икономически растеж, запазване на работните
          места и постигане в дългосрочен план на устойчива заетост.
        </p>
      </div>

      <div>
        <h2>ОЧАКВАНИТЕ РЕЗУЛТАТИ</h2>
        <p>
          При успешното реализиране на настоящето проектно предложение се
          изразяват в постигане на положителен ефект "КЛАСИК-2000" ООД за
          преодоляване на икономическите последствия от пандемията COVID-19 и
          стабилност на работни места в дружеството. Очаква се предприятието да
          продължи дейността си за период от минимум 3 месеца след приключването
          на проекта.
        </p>
      </div>

      <div style="text-align: center">
        <img
          src=${europeanFund}
          alt="Covid Support"
          style="width: 300px"
        />
        <img
          src=${europeanFund2}
          alt="Covid Support"
          style="width: 300px"
        />
      </div>

      <div>
        <p>
          Проект и главна цел: BG16RFOP002-2.077-0406-C01 "Подкрепа за средни
          предприятия за преодоляване на икономическите последствия от
          пандемията COVID-19". Осигуряване на оперативен капитал и постигане на
          положителен ефект за преодоляване икономическите последствия от
          пандемията COVID-19 и стабилност на работните места.
        </p>
      </div>

      <div>
        <p>Бенефициент: КЛАСИК-2000 ООД</p>
        <p>
          Обща стойност: 150 000 лв., от които 127 500 лв. европейско и 22 500
          лв. национално съфинансиране.
        </p>
        <p>Начало: 03.02.2021 г.</p>
        <p>Край: 03.05.2021 г.</p>
      </div>

      <div>
        <p>
          Проект BG16RFOP002-2.077-0406-C01 "Подкрепа за средни предприятия за
          преодоляване на икономическите последствия от пандемията COVID-19"
          финансиран от Оперативна програма "Иновации и конкурентоспособност",
          съфинансирана от Европейския съюз чрез Европейския фонд за регионално
          развитие.
        </p>
      </div>

      <div>
        <p>
          Този документ е създаден с финансовата подкрепа на Оперативна програма
          "Иновации и конкурентоспособност" 2014-2020, съфинансирана от
          Европейския съюз чрез Европейския фонд за регионално развитие. Цялата
          отговорност за съдържанието на документа се носи от КЛАСИК-2000 ООД и
          при никакви обстоятелства не може да се приема, че този документ
          отразява официалното становище на Европейския съюз и Управляващия
          орган.
        </p>
      </div>

      <div>
        <p>Последна актуализация: 04.02.2021 г.</p>
      </div>`,
  },
};
